import { ReactComponent as Icon } from "components/common/Icons/Progress/Pie/CompleteBlue/icon.svg";
interface Props {}

const CompleteBlue = (_: Props) => {
  return <Icon />;
};

export default CompleteBlue;
